
const elements = document.querySelectorAll('.element');

elements.forEach(element =>{
    let question = element.querySelector('.question');
    let btn = element.querySelector('.question button');
    let icon = element.querySelector('.question button i');
    var answer = element.lastElementChild;
    var answers = document.querySelectorAll('.element .answer');
    
    question.addEventListener('click', ()=>{
        answers.forEach(ans =>{
            let ansIcon = ans.parentElement.querySelector('button i');
            if(answer !== ans){
                ans.classList.add('hideText');
                ansIcon.className = 'fas fa-plus-circle';
                ans.parentElement.querySelector('button').setAttribute('aria-expanded', 'false');
            }
        });
        
        answer.classList.toggle('hideText');
        btn.setAttribute('aria-expanded', String(!answer.classList.contains('hideText')));
        icon.className === 'fas fa-plus-circle' ? icon.className = 'fas fa-minus-circle' 
        : icon.className ='fas fa-plus-circle';
    });
});
